<template>
  <div>
    <ProductFilters
      v-if="showFilters"
      :productId.sync="payload.productId"
      :brandId.sync="payload.brandId"
      :supplierId.sync="payload.supplierId"
      :statusId.sync="payload.statusId"
      @apply="getProducts(payload)"
      :action="selected.length > 0"
    />
    <loading v-show="loading" />
    <v-card elevation="0" outlined v-show="!loading">
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title> <h4>Products</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            :items="products"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :items-per-page="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            class="elevation-0 black--text"
          >
            <!-- <template v-slot:header.data-table-select="{ props, on }">
              <COLOR Not working when props.indeterminate is true -->
            <!-- <v-simple-checkbox
                color="primary"
                v-ripple
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox
                color="primary"
                v-ripple
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template> -->
            <template slot="item" slot-scope="props">
              <tr @click="edit(props.item.id)">
                <td>
                  <v-simple-checkbox
                    color="primary"
                    v-ripple
                    @input="select($event)"
                  ></v-simple-checkbox>
                </td>
                <td class="text-left">
                  <v-avatar size="30px">
                    <img
                      v-if="props.item.images.length > 0"
                      :src="props.item.images[0].imageUrl"
                      :alt="props.item.name"
                    />
                  </v-avatar>
                </td>
                <td @click.stop>
                  <v-switch
                    v-if="statuses && statuses.length>0"
                    :true-value="statuses[0].id"
                    :false-value="statuses[1].id"
                    @change="toggleActive($event, props.item.id)"
                    color="green"
                    v-model="props.item.productStatusId"
                  >
                  </v-switch>
                </td>
                <td class="text-left">
                  {{ props.item.createdAt | relativeCreationDate }}
                </td>
                <td class="text-left">
                  {{ props.item.name }}
                </td>
                <td class="text-left">{{props.item.brand? props.item.brand.name:'' }}</td>
                <td class="text-left">
                  {{ props.item.supplier?props.item.supplier.name:'' }}
                </td>
                <td class="text-left">
                  {{ props.item.currency }} {{ props.item.amount }}
                </td>
              </tr>
            </template>

            <!-- <template v-slot:item.approved="{ item }">
            <v-switch
              @change="toggleApproved($event, item.id)"
              color="green"
              v-model="item.approved"
            ></v-switch>
          </template> -->

            <template v-slot:item.action="{ item }" v-if="actions">
              <v-menu offset-y bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon class="gray--text">more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item link>
                    <v-list-item-title @click="edit(item.id)"
                      >Edit</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item link>
                    <v-list-item-title @click="deleteAndRefresh(item.id)"
                      >Delete</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <!-- <template v-slot:item.amount="{ item }">
              {{ parseFloat(item.amount).toFixed(2) }}
            </template> -->
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// eslint max-nested-callbacks: ["error", 10]
import moment from "moment";
import VuemomentJS from "vue-momentjs";
import Helpers from "@/mixins/helpers.js";
import ProductFilters from "./ProductFilters.vue";
export default {
  components: {
    ProductFilters
  },
  props: {
    payload: {
      type: Object,
      default: () => {
        return {
          from: 0,
          to: 10,
          statusId: null,
          brandId: null,
          supplierId: null
        };
      }
    },
    module: {
      type: String,
      default: "products/LOAD_PRODUCTS"
    },
    actions: {
      type: Boolean,
      default: true
    },
    showFilters: {
      default: true,
      type: Boolean
    }
  },
  mixins: [Helpers],
  filters: {
    relativeCreationDate: function(date) {
      return moment.utc(date).fromNow();
    }
  },
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "image"
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "status"
        },
        {
          text: "Created",
          align: "left",
          value: "id",
          sortable: false
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Brand",
          align: "left",
          value: "brand.name"
        },
        {
          text: "Supplier",
          align: "left",
          value: "supplier.name"
        },
        { text: "Amount", value: "amount" },
        { text: "", value: "action", align: "right" }
      ]
    };
  },
  computed: {
    products() {
      return this.$store.state.products.products;
    },
    statuses() {
      return this.$store.state.productstatuses.statuses;
    },
    totalItems() {
      return this.$store.state.products.totalProducts;
    }
  },
  watch: {
    selected(val) {
      val.length > 0
        ? this.$emit("enable-action")
        : this.$emit("disable-action");
    }
  },
  created() {
    if (this.actions == false) {
      this.headers = this.headers.filter(column => column.value !== "action");
    }
    setTimeout(() => {
      this.getProducts(this.payload);
    }, 1000);
  },
  methods: {
    async toggleActive(val, id) {
      let title =
        val == this.statuses[0].id
          ? "Activating product..."
          : "deactivating product...";
      let updateText =
        val == this.statuses[0].id
          ? "Product activated."
          : "Product deactivated";
      this.$swal({
        title: title,
        html: "this will only take a moment...",
        onOpen: () => {
          this.$swal.showLoading();
        }
      });
      await this.$store
        .dispatch("products/UPDATE_STATUS", {
          id: id,
          value: val
        })
        .then(response => {
          this.$swal("success", updateText, "success");
        })
        .catch(error => {
          this.$swal("error", error.message, "error");
        });
    },
    getProducts(payLoad) {
      this.loading = true;
      this.$store
        .dispatch(this.module, payLoad)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.$swal("error", error.message, "error");
        });
    },
    updatePagination(pagination) {
      let payLoad = this.payload;
      (payLoad.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage),
        (payLoad.to =
          pagination.itemsPerPage === -1
            ? this.totalItems
            : pagination.itemsPerPage);
      this.getProducts(payLoad);
    },
    toggleApproved(state, productId) {
      let title = !state ? "Unapproving product..." : "Approving product...";
      let updateText = !state ? "Product unapproved." : "Product approved";
      this.$swal({
        title: title,
        html: "this will only take a moment...",
        onOpen: () => {
          this.$swal.showLoading();
        }
      });

      let payLoad = {
        active: state,
        productId: productId,
        supplierId: this.supplierId
      };

      this.$store
        .dispatch("menu/UPDATE_PRODUCT_APPROVED_STATUS", payLoad)
        .then(response => {
          this.$swal("success", updateText, "success");
        })
        .catch(error => {
          this.$swal("error", error.message, "error");
        });
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        let payLoad = {
          from:
            this.pagination.page * this.pagination.itemsPerPage -
            this.pagination.itemsPerPage,
          to:
            this.pagination.itemsPerPage === -1
              ? this.totalItems
              : this.pagination.itemsPerPage
        };
        this.getProducts(payLoad);
      }
    }
  }
};
</script>
